import { render, staticRenderFns } from "./ShipsPI.vue?vue&type=template&id=ed829268&scoped=true&"
import script from "./ShipsPI.vue?vue&type=script&lang=js&"
export * from "./ShipsPI.vue?vue&type=script&lang=js&"
import style0 from "./ShipsPI.vue?vue&type=style&index=0&id=ed829268&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed829268",
  null
  
)

export default component.exports